import React from 'react'
import './Contacto.css'
import TitleContentSection from '../titlecontentsection/TitleContentSection'
import MessageBox from '../messagebox/MessageBox'
import {ModalContainer, ModalDialog} from 'react-modal-dialog'
import BaseComponent from '../basecomponent/BaseComponent'
import SingleInput from '../formcomponents/SingleInput'
import TextArea from '../formcomponents/TextArea'
import ReactLoading from 'react-loading'
import {privacyPolicy} from '../../constants/constants'
import FacebookIcon from '../common/facebook.svg'
import InstagramIcon from '../common/instagram.svg'

const FORM_URL = "https://5fjjngbvl1.execute-api.eu-west-3.amazonaws.com/Prod";
//const FORM_URL = "http://www.dentalbalmes.com/contacto.php";


class ServicioItem extends React.Component {

    constructor(props){
        super(props)
        let { name, description } = props
        this.name = name
        this.description = description
        this.state = {isShowingModal: false}
    }

    handleClick = () => this.setState({isShowingModal: true})
    handleClose = () => this.setState({isShowingModal: false})

    render(){
        return (<span onClick={this.handleClick} className={"privacy-policy-span"}>
            {this.name}
            {this.state.isShowingModal &&
            <ModalContainer onClose={this.handleClose}>
                <ModalDialog onClose={this.handleClose} className="DIALOG">
                <h1>{this.name.toUpperCase()}</h1>
                <div dangerouslySetInnerHTML={{__html: this.description}}></div>
                </ModalDialog>
            </ModalContainer>}

        </span>)
    }
}

const schedule = [
    {
        day: "Lunes",
        schedule: "09:30 - 13:00 | 15:00 - 20:00"
    }, {
        day: "Martes",
        schedule: "09:30 - 13:00 | 15:00 - 20:00"
    }, {
        day: "Jueves",
        schedule: "15:00 - 20:00"
    }, {
        day: "Viernes",
        schedule: "09:30 - 13:00 | 15:30 - 19:00"
    }
]

const HorarioItem = ({item}) => (
    <li className="Contacto-Info-Horario-List-Item"><strong>{item.day}</strong>: {item.schedule}</li>
)

const Horario = () => (

    <MessageBox title="Horario" className="Contacto-Info-Box Contacto-Info-Horario">
        <ul className="Contacto-Info-Horario-List">
            {schedule.map((e, i) => <HorarioItem key={i} item={e} />)}
        </ul>
    </MessageBox>
)

const InfoContacto = () => (
    <MessageBox title="Contacto" className="Contacto-Info-Box Contacto-Info-Contacto">
        <ul className="Contacto-Info-Contacto-List">
            <li className="Contacto-Info-Contacto-List-Item"><strong>Teléfono: </strong><a href="tel:938052969">93 805 29 69</a></li>
            <li className="Contacto-Info-Contacto-List-Item"><strong>E-mail: </strong><a href="mailto:recepcion@dentalbalmes.com">recepcion@dentalbalmes.com</a></li>
        </ul>

        <div className="Contacto-Info-SocialMedia-List">
            <a href="https://www.facebook.com/Dental-Balmes-Igualada-109282414104534/"><img src={FacebookIcon} alt="Facebook icon"/></a>
            <a href="https://www.instagram.com/dentalbalmesigualada/"><img src={InstagramIcon} alt="Instagram icon"/></a>
        </div>

    </MessageBox>
)


const InfoComponent = () => (
    <div className="Contacto-Section Contacto-Info">
        <Horario />
        <InfoContacto />
    </div>
)

class FormComponent extends React.Component {

    constructor(props){
        super(props)
        this.onNameChange = this.onNameChange.bind(this)
        this.onEmailChange = this.onEmailChange.bind(this)
        this.onMessageChange = this.onMessageChange.bind(this)
        this.onCheckBoxChange = this.onCheckBoxChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)

        // Initial state
        this.state = {
            name: "",
            email: "",
            message: "",
            nameError: false,
            emailError: false,
            messageError: false,
            sending: false,
            sent: false,
            errorSending: false,
            checkboxStatus: false
        }
    }

    onNameChange(e){

        let newState = {
            name: e.target.value,
            nameError: false
        }

        this.setState(newState)
    }

    onEmailChange(e){
        let newState = {
            email: e.target.value,
            emailError: false
        }

        this.setState(newState)
    }

    onMessageChange(e){
        let newState = {
            message: e.target.value,
            messageError: false
        }

        this.setState(newState)
    }

    onCheckBoxChange(e) {
        let newState = {
            checkboxStatus: !this.state.checkboxStatus
        }
        this.setState(newState)
    }

    encodeToFormData(obj){
        let query = ""
        for (let key in obj) {
            query += encodeURIComponent(key)+"="+encodeURIComponent(obj[key])+"&";
        }
        return query
    }

    sendForm(){


        if(!this.state.checkboxStatus) {
            alert('Debe aceptar la política de privacidad')
            return
        }

        // Show loading dialog
        this.setState({sending: true, errorSending: false, sent: false})

        let payload = {
            name: this.state.name,
            email: this.state.email,
            mensaje: this.state.message
        }

        //let encoded = this.encodeToFormData(payload)

        fetch(FORM_URL, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
              },
              method: "POST",
              body: JSON.stringify(payload)
        }).then(res => {
            let newState = {};
            console.log(res)
            if(res.status === 200){
                // Clear form and show OK
                newState = {
                    name: "",
                    email: "",
                    message: "",
                    nameError: false,
                    emailError: false,
                    messageError: false,
                    sending: false,
                    sent: true,
                    errorSending: false,
                    checkboxStatus: false
                }

                setTimeout(() => {
                    this.setState({sent:false})
                }, 3000)

            } else {
                newState = {
                    sending: false,
                    sent: false,
                    errorSending: true
                }
            }

            this.setState(newState)
        })
        .catch(res => {
            let newState = {
                sending: false,
                sent: false,
                errorSending: true
            }
            this.setState(newState)
        })
    }

    handleSubmit(e){

        e.preventDefault()

        // Check

        let error = false
        let newState = {}
        if(this.state.name.length === 0){
            newState.nameError = true
            error = true
        }

        if(this.state.email.length === 0){
            newState.emailError = true
            error = true
        } else if (this.state.email.indexOf('@') === -1){
            newState.emailError = true
            error = true
        }

        if(this.state.message.length === 0){
            newState.messageError = true
            error = true
        }

        if(!error){
            // Do submit
            this.sendForm()

        } else {
            this.setState(newState, () => console.log(`State changed: ${JSON.stringify(this.state)}`))
        }
    }

    getNameClassname(){
        return this.state.nameError ? "input-error" : ""
    }

    getEmailClassName(){
        return this.state.emailError ? "input-error" : ""
    }

    getMessageClassName(){
        return this.state.messageError ? "input-error" : ""
    }

    getFormFooter(){
        if(this.state.sending === true){
            // Return Loading Spinner
            return "";
        } else {
            // Return normal send buttom
            return(
                <div>
                <div className={"privacy-policy-container"}>
                    <input type="checkbox" onChange={this.onCheckBoxChange} checked={this.state.checkboxStatus}/>Acepto la <ServicioItem name="política de privacidad y aviso legal" description={privacyPolicy} />
                </div>
                <input type="submit" value="Enviar" />
                </div>
            )
        }
    }

    render(){
        return(
            <form className="Contacto-Form-Element" onSubmit={this.handleSubmit}>
                <SingleInput
                    id="NameInput"
                    inputType={'text'}
                    title={'Nombre'}
                    name={'name'}
                    content={this.state.name}
                    placeholder={'Escribe tu nombre'}
                    controlFunc={this.onNameChange}
                    className={this.getNameClassname()} />

                <SingleInput
                    id="EmailInput"
                    inputType={'email'}
                    title={'E-mail'}
                    name={'email'}
                    content={this.state.email}
                    placeholder={'Escribe tu correo electrónico'}
                    controlFunc={this.onEmailChange}
                    className={this.getEmailClassName()} />

                <TextArea
                    id="MessageInput"
					title={'Mensaje'}
					rows={10}
					resize={false}
					content={this.state.message}
					name={'message'}
					controlFunc={this.onMessageChange}
                    placeholder={'Escribe tu mensaje'}
                    className={this.getMessageClassName()} />

                {this.state.sent ? <p className="send-message success">El mensaje ha sido enviado</p> : ""}
                {this.state.errorSending ? <p className="send-message error">Ha ocurrido un error enviando el mensaje</p> : ""}
                {this.state.sending ? <ReactLoading delay={100} type="spinningBubbles" color="#444" /> : "" }

                {this.getFormFooter()}

            </form>
        )
    }
}

const ContactFormComponent = () => (
    <div className="Contacto-Section Contacto-Form">
        <h3 className="Contacto-Form-Title">Contáctanos</h3>
        <FormComponent />
    </div>
)

const ContactoComponent = () => (

    <div className="Contacto">
        <TitleContentSection
            title="¿Tiene alguna duda? Solo tiene que preguntar"
            content="Aquí tiene un formulario mediante el cual nos puede enviar cualquier consulta que tenga, ya sea sobre la clínica o sobre cualquier otro aspecto. ¡Estaremos encantados de ayudarle!"
        />

        <div className="Contacto-Content">

            <ContactFormComponent />
            <InfoComponent />

        </div>


    </div>

)

const Contacto = BaseComponent(ContactoComponent, "Contacto")

export default Contacto



// WEBPACK FOOTER //
// ./src/components/contacto/Contacto.js